import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import ActionBtn from "../../../common/management/ActionBtn";
import { timestampToTime } from "../../../utils/GeneralUtils";
import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  id: string;
  status: string;
  timestamp: number;
  memo: string;
  fromName: string;
  to: string;
  recipientName: string;
  isSelect: boolean;
  handleModal: () => void;
  handleModalProps: (value: string) => void;
};

const OfferListItem: React.FC<Props> = ({
  id,
  status,
  timestamp,
  memo,
  fromName,
  to,
  recipientName,
  isSelect,
  handleModal,
  handleModalProps,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["offer"]}`}
    >
      <div>{recipientName}</div>
      <div>{to}</div>
      <div>{fromName}</div>
      <div>{timestamp ? timestampToTime(timestamp, false) : null}</div>
      <div>
        <span
          className={
            status === "COMPLETE"
              ? `${styles["status"]} ${styles["open"]}`
              : status === "CANCELLED"
              ? `${styles["status"]} ${styles["close"]}`
              : status === "UNDERGOING_INSPECTION"
              ? `${styles["status"]} ${styles["progress"]}`
              : `${styles["status"]} ${styles["pending"]}`
          }
        >
          {t(`offer.status.${status}`)}
        </span>
      </div>
      <div className={styles["f-dbList__category-action"]}>
        <ActionBtn
          label="対応する"
          icon={["fal", "edit"]}
          link={isSelect ? `/admin/offer/${id}` : `/jikei/offer/${id}`}
        />
        {memo ? (
          <button
            className={styles["f-dbList__category-action__menu"]}
            onClick={() => {
              handleModal();
              handleModalProps(memo);
            }}
          >
            <FontAwesomeIcon icon={["fas", "file-alt"]} />
          </button>
        ) : (
          <>
            <FontAwesomeIcon icon={["fas", "file-alt"]} />
          </>
        )}
      </div>
    </div>
  );
};

export default OfferListItem;
